import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { I18nProvider } from "./i18n/I18nContext";
import Layout from "./components/Layout";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import HomeApp from "./pages/HomeApp";
import Browse from "./pages/Browse";
import PostRequest from "./pages/PostRequest";
import RequestDetail from "./pages/RequestDetail";
import Messages from "./pages/Messages";
import Profile from "./pages/Profile";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import VerifyEmail from "./pages/VerifyEmail";
import Wall from "./pages/Wall";
import MapPage from "./pages/MapPage";
import AdminUsers from "./pages/AdminUsers";
import Impressum from "./pages/Impressum";
import Privacy from "./pages/Privacy";

export default function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster richColors position="top-right" />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Landing />} />
              <Route path="/login" element={<Login />} />
              <Route path="/registrati" element={<Register />} />
              <Route path="/password-dimenticata" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/verifica-email" element={<VerifyEmail />} />
              <Route path="/muro-degli-aiuti" element={<Wall />} />
              <Route path="/impressum" element={<Impressum />} />
              <Route path="/privacy" element={<Privacy />} />

              <Route path="/app" element={<ProtectedRoute><HomeApp /></ProtectedRoute>} />
              <Route path="/app/cerca" element={<ProtectedRoute><Browse /></ProtectedRoute>} />
              <Route path="/app/mappa" element={<ProtectedRoute><MapPage /></ProtectedRoute>} />
              <Route path="/app/nuova" element={<ProtectedRoute><PostRequest /></ProtectedRoute>} />
              <Route path="/app/richieste/:id" element={<ProtectedRoute><RequestDetail /></ProtectedRoute>} />
              <Route path="/app/messaggi" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
              <Route path="/app/messaggi/:userId" element={<ProtectedRoute><Messages /></ProtectedRoute>} />
              <Route path="/app/profilo" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/app/utenti/:userId" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
              <Route path="/app/admin/utenti" element={<ProtectedRoute><AdminUsers /></ProtectedRoute>} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}
